const compraUnicaContainerProductPage = document.getElementById("div-compra-unica-product-page");
const compraUnicaRadiobtnProductPage = document.getElementById("compra-unica-radiobtn-product-page");

const suscripcionContainerProductPage = document.getElementById("compra-subscripcion-product-page");
const subscripcionRadiobtnProductPage = document.getElementById("subscripcion-radiobtn-product-page");
const subscriptionsOptionsProductPage = document.getElementById("subscription-options-product-page");

const textoBtnComprarProductPage = document.getElementById("texto-btn-comprar-product-page");

const sub1MesRadioBtnProductPage = document.getElementById("subscripcion-1mes-radiobtn-product-page");
const sub2MesesRadioBtnProductPage = document.getElementById("subscripcion-2meses-radiobtn-product-page");
const sub3MesesRadioBtnProductPage = document.getElementById("subscripcion-3meses-radiobtn-product-page");

const badgeDescuentoSub1ProductPage = document.getElementById("savvy-prime-procentaje-descuento1-product-page");
const badgeDescuentoSub2ProductPage = document.getElementById("savvy-prime-procentaje-descuento2-product-page");
const badgeDescuentoSub3ProductPage = document.getElementById("savvy-prime-procentaje-descuento3-product-page");

const precioFinalSub1ProductPage = document.getElementById("savvy-prime-precio-final1-product-page");
const precioFinalSub2ProductPage = document.getElementById("savvy-prime-precio-final2-product-page");
const precioFinalSub3ProductPage = document.getElementById("savvy-prime-precio-final3-product-page");

const anchorDetallesSuscripcion = document.getElementById("detalles-suscripcion-anchor-product-page");

function resetStylesCompraUnicaProductPage() {
    compraUnicaContainerProductPage.style.backgroundColor = "rgb(255,255,255)";
    compraUnicaContainerProductPage.style.border = "solid rgb(0 0 0 / 30%)";
    compraUnicaContainerProductPage.style.borderWidth = "2px 2px 0px 2px";
    compraUnicaContainerProductPage.style.borderRadius = "4px 4px 0px 0px";
    compraUnicaContainerProductPage.style.padding = "24px 12px";
}

function resetStylesSubscripcionProductPage() {
    suscripcionContainerProductPage.style.backgroundColor = "rgb(255,255,255)";
    suscripcionContainerProductPage.style.border = "solid rgb(0 0 0 / 30%)";
    suscripcionContainerProductPage.style.borderWidth = "0px 2px 2px 2px";
    suscripcionContainerProductPage.style.borderRadius = "0px 0px 4px 4px";
    suscripcionContainerProductPage.style.padding = "24px 12px";
}

function activarStylesCompraUnicaProductPage() {
    resetStylesSubscripcionProductPage();
    compraUnicaContainerProductPage.style.backgroundColor = "rgb(255,245,237)";
    compraUnicaContainerProductPage.style.border = "2px solid #FFD54F";
    compraUnicaContainerProductPage.style.borderRadius = "4px 4px 0px 0px";
    textoBtnComprarProductPage.textContent = "Agregar producto";

    if(subscriptionsOptionsProductPage){
        subscriptionsOptionsProductPage.style.display = "none";
        sub1MesRadioBtnProductPage.checked = false;
    }
}

function activarStylesSuscripcionProductPage() {
    resetStylesCompraUnicaProductPage();
    suscripcionContainerProductPage.style.backgroundColor = "rgb(255,245,237)";
    suscripcionContainerProductPage.style.border = "solid #FFD54F";
    suscripcionContainerProductPage.style.borderWidth = "2px 2px 0px 2px";
    suscripcionContainerProductPage.style.padding = "24px 12px 0px 12px";
    suscripcionContainerProductPage.style.borderRadius = "0px 0px 0px 0px";
    textoBtnComprarProductPage.textContent = "Agregar suscripción";

    if(subscriptionsOptionsProductPage){
        subscriptionsOptionsProductPage.style.display = "flex";
        sub1MesRadioBtnProductPage.checked = true;
    }
    
}

compraUnicaRadiobtnProductPage.checked = true;
if(compraUnicaRadiobtnProductPage.checked){
    activarStylesCompraUnicaProductPage();
}

compraUnicaRadiobtnProductPage?.addEventListener("click", activarStylesCompraUnicaProductPage);

subscripcionRadiobtnProductPage?.addEventListener("click", ()=>{
    activarStylesSuscripcionProductPage();
    document.getElementById("subscripcion-1mes-radiobtn-product-page").checked = true;
});

sub1MesRadioBtnProductPage?.addEventListener("click", ()=>{
    badgeDescuentoSub1ProductPage.style.display = "block";
    badgeDescuentoSub2ProductPage.style.display = "none";
    badgeDescuentoSub3ProductPage.style.display = "none";

    precioFinalSub1ProductPage.style.display = "block";
    precioFinalSub2ProductPage.style.display = "none";
    precioFinalSub3ProductPage.style.display = "none";
});

sub2MesesRadioBtnProductPage?.addEventListener("click", ()=>{
    badgeDescuentoSub1ProductPage.style.display = "none";
    badgeDescuentoSub2ProductPage.style.display = "block";
    badgeDescuentoSub3ProductPage.style.display = "none";

    precioFinalSub1ProductPage.style.display = "none";
    precioFinalSub2ProductPage.style.display = "block";
    precioFinalSub3ProductPage.style.display = "none";
});

sub3MesesRadioBtnProductPage?.addEventListener("click", ()=>{
    badgeDescuentoSub1ProductPage.style.display = "none";
    badgeDescuentoSub2ProductPage.style.display = "none";
    badgeDescuentoSub3ProductPage.style.display = "block";

    precioFinalSub1ProductPage.style.display = "none";
    precioFinalSub2ProductPage.style.display = "none";
    precioFinalSub3ProductPage.style.display = "block";
});

document.addEventListener("DOMContentLoaded", function () {
    if (anchorDetallesSuscripcion) {
        anchorDetallesSuscripcion.addEventListener("click", function (event) {
            event.preventDefault();
            
            const targetSection = document.querySelector(anchorDetallesSuscripcion.getAttribute("href"));

            if (targetSection) {
                targetSection.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }
        });
    }
});

//Metodo para tratar de hacer metaetiqueta de producto

document.addEventListener("DOMContentLoaded", function () {
    // Seleccionar el botón que contiene el atributo data-product
    var button = document.querySelector("[data-product]");

    if (button) {
        var productData = button.getAttribute("data-product");

        if (productData) {
            // Crear la metaetiqueta
            var metaTag = document.createElement("meta");
            metaTag.setAttribute("property", "og:product");
            metaTag.setAttribute("content", productData);

            // Insertar en el <head>
            document.head.appendChild(metaTag);
        }
    }

    const divCompraUnica = document.getElementById('div-compra-unica-product-page');
    const divSuscripcion = document.getElementById('compra-subscripcion-product-page');

    const radioButton = divCompraUnica.querySelector('#compra-unica-radiobtn-product-page');
    const radioButtonSuscripcion = divSuscripcion.querySelector('#subscripcion-radiobtn-product-page');

    if (divCompraUnica && radioButton) {
        divCompraUnica.addEventListener('click', function(event) {

            radioButton.click();
        });
    } else {
        if (!divCompraUnica) console.error('No se encontró el div #div_compra_unica');
        if (!radioButton) console.error('No se encontró el radio button .compra-unica-radiobtn-overlay dentro del div');
    }
    if (divSuscripcion && radioButtonSuscripcion) {
        divSuscripcion.addEventListener('click', function(event) {

            radioButtonSuscripcion.click();

        });
    } else {
        if (!divSuscripcion) console.error('No se encontró el div #div_compra_unica');
        if (!radioButtonSuscripcion) console.error('No se encontró el radio button .compra-unica-radiobtn-overlay dentro del div');
    }
});
/*

document.getElementById("div-compra-unica-product-page")?.addEventListener("click", function () {
    const radio = document.getElementById("compra-unica-radiobtn-product-page");
    if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event("click")); // Opcional: activa el mismo comportamiento que si el usuario hiciera clic
    }
});

document.getElementById("compra-subscripcion-product-page")?.addEventListener("click", function () {
    const radioSubscripcion = document.getElementById("subscripcion-radiobtn-product-page");
    const radioSub1Mes = document.getElementById("subscripcion-1mes-radiobtn-product-page");

    if (radioSubscripcion) {
        radioSubscripcion.checked = true;
        radioSubscripcion.dispatchEvent(new Event("click")); // Activa estilos de suscripción
    }

    if (radioSub1Mes) {
        radioSub1Mes.checked = true;
        radioSub1Mes.dispatchEvent(new Event("click")); // Muestra el descuento y precio del plan de 1 mes
    }
});
*/